import { Component, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { FacilitiesService } from '../../../../core/facilities/facilities.service';
import { ChartOptionsFactory } from '../../../chart-options-factory';
import Highcharts from 'highcharts';
import * as api from "../../../../api";
import { AbstractAggregateChartsComponent } from "../../abstract-aggregate-charts.component";
import { LoadingError } from "../../../../core/error-catching.service";
import { takeUntil, catchError } from 'rxjs/operators';
import { ApiRequestDto } from '../../../../api';

/**
 * PRN (Latin "Pro re nata" meaning "as needed") Psychoactive Medications Summary Widget - shows pair of charts.
 */
@Component({
    selector: 'my-psychotropic-dash-summary-donut-charts',
    template: `
        <div class="{{summary ? 'col-4' : 'col-6'}}">
            <div #donutChart></div>
        </div>
    `,
    inputs: AbstractAggregateChartsComponent.INPUTS

})
export class PsychotropicDashSummaryDonutComponent extends AbstractAggregateChartsComponent implements AfterViewInit {

    ////// Donut Chart
    @ViewChild('donutChart', {static: false} ) donutChartDivRef: ElementRef;
    private donutChart: Highcharts.Chart;

    @Input()
    summary: boolean = true;

    @Input()
    fixedLegend: boolean;

    /** Construct */
    constructor(
        private psychotropicSummaryService: api.PsychotropicSummaryService,
        facilitiesSvc: FacilitiesService,
    ) {
        super(facilitiesSvc);
    }

        /**
     * Setup the charts.
     * @override
     */
    buildAllCharts(): void {
        this.chartTitle = 'Residents on Psychotropic Medications'
        let donutChartOptions = ChartOptionsFactory.buildDonutType(this.chartTitle);

        if(this.fixedLegend){
            donutChartOptions.tooltip = {
                headerFormat: "",
                pointFormat: "<b>{point.y}</b>"
            };
        }


        this.donutChart = super.createChart(this.donutChartDivRef, donutChartOptions);
    }

    /**
     * Fetch all data and update display
     * @override
     */
    fetchAndPopulate(): void {
        const requestParams: ApiRequestDto = {
            StartDate: this.dateRange.startJsDateUTC,
            EndDate: this.dateRange.endJsDateUTC,
            OrgList: this.facilitiesSvc.selectedAsOrgList
        };
        this.psychotropicSummaryService.psychotropicSummaryGetPsychotropicsPercentage(requestParams)
            .pipe(takeUntil(this.stop$),
                catchError((error)=>{
                    throw new LoadingError(this.chartTitle);
                }))
            .subscribe((residentCount: api.MedicationSummaryCountResult) => {
                if(this.fixedLegend){
                    ChartOptionsFactory.addHiddenLegendItems(residentCount, 6);
                }

                this.populateMedSummaryCountDonut(this.donutChart, residentCount, true);
                ChartOptionsFactory.disableHiddenItemsHoverInLegend(this.donutChart);
            });
    }
}
